'use client';

import { type ReportWebVitalsCallback, sendWebVital } from '@/helper/webVitalsTelemetry';
import { useReportWebVitals } from 'next/web-vitals';

/**
 * Stable module-level callback so Next.js does not re-report already available vitals
 * when the component re-renders.
 */
const reportWebVitals: ReportWebVitalsCallback = (metric) => {
  void sendWebVital(metric);
};

/**
 * Global Core Web Vitals reporter. Renders nothing; mount exactly once in the app tree.
 */
export default function WebVitalsReporter(): null {
  useReportWebVitals(reportWebVitals);
  return null;
}
